// start:ng42.barrel
export * from './editor.component';
// end:ng42.barrel

